export enum QueryParam {
  modalKey = 'modal',
  screenKey = 'modalScreen',
  authModalValue = 'auth',
  installAppModalValue = 'installApp'
}
